import React from 'react';
import VolNav from '../../components/vol/VolNav';
import { useVolunteerAuth } from '../../hooks/useVolunteerAuth';
import './Vol.css';

function VolProfile() {
  const { volunteer, firebaseUser } = useVolunteerAuth();

  if (!volunteer) return null;

  const providerLabel = {
    google: 'Google',
    microsoft: 'Microsoft',
    yahoo: 'Yahoo',
    apple: 'Apple',
  }[volunteer.authProvider] || volunteer.authProvider || 'Unknown';

  return (
    <div className="vol-page">
      <VolNav />
      <div className="vol-content">
        <header className="vol-page-header">
          <h1>My Profile</h1>
        </header>

        <div className="vol-card" style={{ maxWidth: '560px' }}>
          <h2 className="vol-card-title">Account</h2>
          <div className="vol-info-row">
            <span className="vol-info-label">Signed in as</span>
            <span>{firebaseUser?.email}</span>
          </div>
          <div className="vol-info-row">
            <span className="vol-info-label">Sign-in method</span>
            <span>{providerLabel}</span>
          </div>
          {volunteer.profileLinkedAt && (
            <div className="vol-info-row">
              <span className="vol-info-label">Linked on</span>
              <span>{new Date(volunteer.profileLinkedAt).toLocaleDateString()}</span>
            </div>
          )}
        </div>

        <div className="vol-card" style={{ maxWidth: '560px', marginTop: '20px' }}>
          <h2 className="vol-card-title">Volunteer Details</h2>
          {[
            ['Name', `${volunteer.firstName || ''} ${volunteer.lastName || ''}`.trim()],
            ['Email', volunteer.email],
            ['Phone', volunteer.phone],
            ['Congregation', volunteer.congregation],
            ['Marital Status', volunteer.maritalStatus],
            ['Spouse', volunteer.spouseName],
            ['Emergency Contact', volunteer.emergencyContactName],
            ['Emergency Phone', volunteer.emergencyContactPhone],
          ].filter(([, v]) => v).map(([label, value]) => (
            <div key={label} className="vol-info-row">
              <span className="vol-info-label">{label}</span>
              <span>{value}</span>
            </div>
          ))}
        </div>

        <p className="vol-profile-note" style={{ marginTop: '16px', fontSize: '13px', color: '#64748b' }}>
          To update your information, please contact the SMPW scheduling team.
        </p>
      </div>
    </div>
  );
}

export default VolProfile;
